import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

type PolicyType = 'terms' | 'privacy' | 'cookies' | 'refund';

interface PolicyPageProps {
  type: PolicyType;
}

const sectionCounts: Record<PolicyType, number> = {
  terms: 8,
  privacy: 6,
  cookies: 3,
  refund: 5,
};

const PolicyPage: React.FC<PolicyPageProps> = ({ type }) => {
  const { t } = useTranslation('portal');
  const navigate = useNavigate();
  const count = sectionCounts[type];

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <button
          type="button"
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-6"
        >
          <ArrowLeft className="w-4 h-4" />
          {t('policies.backToHome')}
        </button>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            {t(`policies.${type}.title`)}
          </h1>
          <p className="text-sm text-gray-500 mb-6">
            {t(`policies.${type}.lastUpdated`)}
          </p>
          <p className="text-gray-700 mb-8 leading-relaxed">
            {t(`policies.${type}.intro`)}
          </p>

          <div className="space-y-6">
            {Array.from({ length: count }, (_, i) => i + 1).map((num) => (
              <div key={num}>
                <h2 className="text-lg font-semibold text-gray-900 mb-2">
                  {t(`policies.${type}.section${num}Title`)}
                </h2>
                <p className="text-gray-700 leading-relaxed whitespace-pre-line">
                  {t(`policies.${type}.section${num}Text`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolicyPage;
